/*global ym*/
import Cookie from "js-cookie"

import {
    IS_PRODUCTION,
    ANALYTIC_DEBUG_SHOW_LOG,
    YANDEX_METRIKA_COUNTER_ID,
} from "utils/env-management"
import { isBrowser } from "utils/infrastructure/ssg-utils"

type Event = ym.Event
type Options = ym.HitOptions<unknown>

export function getYmClientId() {
    return Cookie.get("_ym_uid")
}

const ymQueue: Array<() => void> = []

export function ymSendHit(url: string, options: Options) {
    const ym: Event = window.ym
    if (!window.ym) {
        ymQueue.push(() => ymSendHit(url, options))
        if (ANALYTIC_DEBUG_SHOW_LOG) {
            console.log(
                `Y.Metrika is not ready, queued: ym(XXX, 'hit', ${JSON.stringify(
                    url
                )}, ${JSON.stringify(options, null, 2)})`
            )
        }
        return
    }
    if (IS_PRODUCTION) {
        ym(YANDEX_METRIKA_COUNTER_ID as unknown as number, "hit", url, options)
    } else if (ANALYTIC_DEBUG_SHOW_LOG) {
        console.log(
            `ym('${YANDEX_METRIKA_COUNTER_ID}', "'hit'", ${JSON.stringify(url)}, ${JSON.stringify(
                options,
                null,
                2
            )})`
        )
    }
}

if (isBrowser()) {
    document.addEventListener(`yacounter${YANDEX_METRIKA_COUNTER_ID}inited`, function () {
        if (ANALYTIC_DEBUG_SHOW_LOG) {
            console.log(`Y.Metrika counter ready, executing ${ymQueue.length} queue tasks`)
        }
        ymQueue.forEach((action) => action())
        if (ANALYTIC_DEBUG_SHOW_LOG) {
            console.log("Y.Metrika queue is fully executed")
        }
    })
}
